import { assoc, is, path } from 'ramda'

export default {
  /**
   * Adds a flash notification.
   *
   * @param {Object} state
   * @param {Object} notification
   */
  ADD(state, notification) {
    state.notification = notification
  },

  /**
   * Hides the notification in the store.
   *
   * This starts the animation to hide the notification.
   *
   * @param {Object} state
   */
  HIDE(state, id = null) {
    if (is(Object, state.notification) && (path(['notification', 'id'], state) === id || id === null)) {
      state.notification = assoc('hiding', true, state.notification)
    }
  },

  /**
   * Remove the notification in the store.
   *
   * @param {Object} state
   */
  REMOVE(state, id = null) {
    if (path(['notification', 'id'], state) === id || id === null) {
      state.notification = null
    }
  },
}
